import groupController from './controllers/groupCreationController';
import assignController from './controllers/assignUserController';
import './assignUsers.scss';
import _ from "underscore"
var module = angular.module('AssignUserModule', [
]).controller('assignController', assignController)
.controller('groupController', groupController);
module.constant('ASSIGN_USER_CONSTANT', {
    API_GET_STUDENT_LIST: "/v0/assign-users/student-details/",
    API_GET_ASSIGNED_USERS: "/v0/assign-users/assignee-details/",
    API_GET_GROUP_DETAILS: "/v0/assign-users/get-group-details/",
    API_UPDATE_ASSIGNEE_DETAILS: "/v0/assign-users/update-assignee-details/",
    API_DELETE_GROUP: "/v0/assign-users/delete-group/",
    API_STUDENT_GROUP_DETAILS: "/v0/assign-users/student-group-details/",
    API_ADD_STUDENT_GROUP: "/v0/assign-users/create-group/",
    API_UPDATE_STUDENT_GROUP: "/v0/assign-users/edit-group/",
    API_UPDATE_RESOURCE_ASSIGNEE_DETAILS: "/v0/assign-users/update-resource-assignee-details"

})

module.config(function($stateProvider, $locationProvider) {
    "ngInject";
    $stateProvider
        /*.state('assignUsers', {
            parent: 'app',
            url: '/assign-users/:planId',
            params: {
                previousState: {
                    state: '',
                    params: {}
                }
            },
            views: {
                '@': {
                    template: assignUsers,
                    controller: assignController,
                    controllerAs: 'assignController'
                }
            }
        })
        .state('createGroup', {
            parent: 'app',
            url: '/create-group/:planId/:groupId',
            params: {
                previousState: {}
            },
            views: {
                '@': {
                    template: createGroup,
                    controller: groupController,
                    controllerAs: 'groupController'
                }
            }
        })*/
});



// WEBPACK FOOTER //
// ./src/app/authoring-tool/assignUsers/assignUserModule.js